<template>
    <div class="step">
        <div class="step__container">

            <!-- Title -->
            <div class="step__title" ref="title">
                <p>Your Ohana phone number</p>
            </div>

            <!-- Subtitle -->
            <div class="step__subtitle" ref="subtitle">
                <p>Write this down and use it to text and call your loved one.</p>
            </div>

            <div class="step__you-phone" ref="phone">
                <p>{{ ohanaNumber }}</p>
            </div>

            <!-- Next Button -->
            <div class="step__button step__button--bottom" ref="button">
                <a href="#" @click.prevent="goNextStep" class="button">
                    <span>Next</span>
                </a>
            </div>

        </div>
    </div>
</template>

<script>

    import { TimelineMax } from 'gsap';

    export default {
        name: 'Step7_OhanaNum',
        data() {
            return {
                ohanaNumber: ''
            }
        },
        methods: {
            goNextStep() {
                this.$emit('nextStep')
            },
            formatPhoneNumber(phoneNumberString) {
                var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
                var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
                if (match) {
                    var intlCode = (match[1] ? '+1 ' : '')
                    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
                }
                return null
            }
        },
        mounted() {

            amplitude.getInstance().logEvent('signup_page_ohananum_loaded');

            const originalNumber = this.$parent.ohanaNumber;
            const oneRemoved = originalNumber.slice(2)
            const formattedNumber = this.formatPhoneNumber(oneRemoved);

            this.ohanaNumber = formattedNumber;

            let tl = new TimelineMax({
                delay: 1
            });
            const {title, subtitle, form, button, phone} = this.$refs;
            tl
            .from([title, subtitle, phone], 1.2, {autoAlpha: 0, ease: Power2.easeOut})
            .from(button, 1.2, {scale: .9, autoAlpha: 0, ease: Power2.easeOut}, "-=.8")
        }
    }
</script>




// WEBPACK FOOTER //
// Step7_OhanaNum.vue?f37922da